export const PROMO_MOBILE_MENU_EVENTS = {
  PROMO_MOBILE_MENU_OPEN: 'promo-mobile-menu-open',
  PROMO_MOBILE_MENU_CLOSE: 'promo-mobile-menu-close',
};

export const PROMO_HEADER_MOBILE_EVENTS = {
  PROMO_HEADER_MOBILE_MENU_TOGGLE: 'promo-header-mobile-menu-toggle',
};
